"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HR = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.hr `
	border-style: solid;

	/* Needs to override AM styles */
	&&& {
		margin: 40px 0;
		border-color: ${(p) => p.theme.palette.border};

		${(p) => p.theme.breakpoints.down("sm")} {
			margin: 32px 0;
		}
	}
`;
const HR = () => {
    return react_1.default.createElement(Styled, null);
};
exports.HR = HR;
//# sourceMappingURL=HR.atom.js.map